var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('image-size-picker',{staticClass:"web-image-size-picker",attrs:{"formats":_vm.outputFormatOptions,"sizes":_vm.sizes,"editable":_vm.editable},on:{"on-sizes-changed":(newSizes) => _vm.$emit('on-sizes-changed', newSizes)}})
}
var staticRenderFns = []

export { render, staticRenderFns }